/*
  Examples page for FullStack.cash
*/

import React from 'react'
import { Helmet } from 'react-helmet-async'
import { Container, Row, Col, Button } from 'react-bootstrap'

function Examples () {
  return (
    <>
      <Helmet>
        <title>Examples - Get Started Quickly - FullStack.cash</title>
      </Helmet>

      <Container className='py-5'>
        <Row className='mb-5'>
          <Col md={6}>
            <div className='text-center mb-4'>
              <h2>Get Started Quick</h2>
            </div>
            <p>
              These bite-sized example applications show you how to create a
              wallet, send BCH, create SLP tokens, read and write text to the
              blockchain, and more. Each example acts like a lego block,
              showing you how to build your way towards common business
              solutions.
            </p>
          </Col>
          <Col md={6} className='text-center'>
            <i className='fas fa-code fa-5x text-primary mb-4' />
            <div>
              <Button
                href='https://github.com/Permissionless-Software-Foundation/psf-js-examples'
                target='_blank'
                rel='noreferrer'
                variant='primary'
                size='lg'
              >
                View Examples on GitHub
              </Button>
            </div>
          </Col>
        </Row>

        <Row className='mb-5'>
          <Col md={6} className='mb-4 mb-md-0'>
            <h2>Getting Started Tutorial</h2>
            <div className='ratio ratio-16x9'>
              <iframe
                title='Bitcoin Cash Full Stack Introduction'
                src='https://www.youtube.com/embed/GD2i1ZUiyrk'
                frameBorder='0'
                allow='accelerometer; encrypted-media; gyroscope; picture-in-picture'
                allowFullScreen
              />
            </div>
          </Col>
          <Col md={6}>
            <h2>Increasing Rate Limits</h2>
            <div className='ratio ratio-16x9'>
              <iframe
                title='Using a JWT Token with FullStack.cash'
                src='https://www.youtube.com/embed/27h-KiS-dPg'
                frameBorder='0'
                allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
                allowFullScreen
              />
            </div>
          </Col>
        </Row>

        <Row>
          <Col>
            <h2 className='text-center mb-4'>Want More? Check this out.</h2>
            <p className='text-center mb-4'>
              The examples above are great to start with, but they are a long
              way from turn-key business solutions. These more advanced
              examples allow you to quickly integrate Bitcoin Cash and SLP
              token functionality into your existing business applications.
            </p>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default Examples
